import { useTranslation } from "react-i18next";
import { LegalPageLayout } from "@/components/marketing/legal-page-layout";

const PRIVACY_SECTION_KEYS = [
    "dataWeCollect",
    "howWeUse",
    "dataSharing",
    "retention",
    "yourRights",
    "cookies",
    "contact",
] as const;

const PRIVACY_LAST_UPDATED = "2025-03-05";

export function PrivacyPage() {
    const { t } = useTranslation("pages:legal");
    const lastUpdatedFormatted = new Date(PRIVACY_LAST_UPDATED).toLocaleDateString(undefined, {
        year: "numeric",
        month: "long",
        day: "numeric",
    });

    return (
        <LegalPageLayout>
            <article className="space-y-10">
                <div>
                    <h1 className="text-3xl font-bold tracking-tight text-primary sm:text-4xl">
                        {t("privacy.title")}
                    </h1>
                    <p className="mt-2 text-sm text-tertiary">
                        {t("lastUpdated")}: {lastUpdatedFormatted}
                    </p>
                </div>
                <div className="space-y-8">
                    {PRIVACY_SECTION_KEYS.map((key) => (
                        <section key={key} id={key}>
                            <h2 className="text-xl font-semibold text-primary mb-3">
                                {t(`privacy.sections.${key}.title`)}
                            </h2>
                            <p className="text-sm text-tertiary leading-relaxed">
                                {t(`privacy.sections.${key}.content`)}
                            </p>
                        </section>
                    ))}
                </div>
            </article>
        </LegalPageLayout>
    );
}
